(function () {
  'use strict';

  // Fix: when the browser restores this page from its back/forward cache
  // (e.g. user clicks "back" after adding to cart), scripts don't re-run
  // and things look frozen — videos don't autoplay again, buttons can stay
  // stuck disabled, etc. Force a real reload in that case so everything
  // re-initializes from scratch, same as a fresh visit.
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      window.location.reload();
    }
  });

  function initReveals() {
    var els = document.querySelectorAll('.db-reveal');
    if (!els.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('db-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('db-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
    els.forEach(function (el, i) {
      el.style.setProperty('--db-delay', Math.min(i % 6, 5) * 90 + 'ms');
      io.observe(el);
    });
  }

  function initCountdown() {
    document.querySelectorAll('[data-db-countdown]').forEach(function (el) {
      var hours = parseInt(el.getAttribute('data-hours'), 10) || 12;
      var storageKey = 'db-countdown-' + el.getAttribute('data-db-countdown');
      var end = Number(sessionStorage.getItem(storageKey));
      if (!end || end < Date.now()) {
        end = Date.now() + hours * 3600 * 1000;
        try { sessionStorage.setItem(storageKey, String(end)); } catch (e) {}
      }
      var hEl = el.querySelector('[data-db-h]');
      var mEl = el.querySelector('[data-db-m]');
      var sEl = el.querySelector('[data-db-s]');
      function tick() {
        var diff = Math.max(0, end - Date.now());
        var h = Math.floor(diff / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        if (hEl) hEl.textContent = String(h).padStart(2, '0');
        if (mEl) mEl.textContent = String(m).padStart(2, '0');
        if (sEl) sEl.textContent = String(s).padStart(2, '0');
        if (diff <= 0) { clearInterval(timer); }
      }
      tick();
      var timer = setInterval(tick, 1000);
    });
  }

  function initGallery() {
    document.querySelectorAll('[data-db-gallery]').forEach(function (gallery) {
      var track = gallery.querySelector('[data-db-slides]');
      if (!track) return;
      var slides = Array.prototype.slice.call(track.querySelectorAll('[data-db-slide]'));
      var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-db-thumb]'));
      var index = 0, raf = null;

      function fitHeight() {
        var img = slides[index] && slides[index].querySelector('img');
        if (img && img.offsetHeight) track.style.height = img.offsetHeight + 'px';
      }
      function setActive(i) {
        if (i === index && track.style.height) return;
        index = i;
        thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
        var th = thumbs[i];
        if (th && th.parentNode) {
          var row = th.parentNode;
          row.scrollTo({ left: th.offsetLeft - (row.clientWidth - th.offsetWidth) / 2, behavior: 'smooth' });
        }
        fitHeight();
      }
      function goTo(i) {
        i = Math.max(0, Math.min(slides.length - 1, i));
        track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
        setActive(i);
      }

      track.addEventListener('scroll', function () {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
          if (i !== index) setActive(i);
        });
      }, { passive: true });

      thumbs.forEach(function (thumb, i) { thumb.addEventListener('click', function () { goTo(i); }); });

      slides.forEach(function (sl, i) {
        var img = sl.querySelector('img');
        if (img && !img.complete) img.addEventListener('load', function () { if (i === index) fitHeight(); });
      });
      window.addEventListener('resize', fitHeight);
      window.addEventListener('load', fitHeight);
      if ('ResizeObserver' in window) {
        var ro = new ResizeObserver(function () { fitHeight(); });
        slides.forEach(function (sl) { var im = sl.querySelector('img'); if (im) ro.observe(im); });
      }
      fitHeight();

      // Raton (ordenador): arrastrar para pasar de foto
      var down = false, startX = 0, startLeft = 0, moved = false;
      track.addEventListener('mousedown', function (e) {
        down = true; moved = false; startX = e.clientX; startLeft = track.scrollLeft;
        track.classList.add('is-dragging');
        document.addEventListener('mousemove', onMove);
        document.addEventListener('mouseup', onUp);
        e.preventDefault();
      });
      function onMove(e) {
        if (!down) return;
        if (e.buttons === 0) { onUp(e); return; }
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 4) moved = true;
        track.scrollLeft = startLeft - dx;
      }
      function onUp(e) {
        if (!down) return;
        down = false;
        track.classList.remove('is-dragging');
        document.removeEventListener('mousemove', onMove);
        document.removeEventListener('mouseup', onUp);
        var dx = e.clientX - startX, w = track.clientWidth;
        var target = Math.round(startLeft / w);
        if (dx < -50) target += 1; else if (dx > 50) target -= 1;
        goTo(target);
      }
      track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
    });
  }

  function initSceneSwitcher() {
    document.querySelectorAll('[data-db-switcher]').forEach(function (widget) {
      var img = widget.querySelector('[data-db-switch-img]');
      var caption = widget.querySelector('[data-db-switch-caption]');
      var buttons = widget.querySelectorAll('[data-db-scene]');
      var auto = widget.getAttribute('data-autoplay') === 'true';
      var index = 0;
      function show(i) {
        index = i;
        var btn = buttons[i];
        if (!btn || !img) return;
        var gen = ++renderToken;
        img.style.opacity = '0';
        setTimeout(function () {
          if (gen !== renderToken) return;
          img.setAttribute('src', btn.getAttribute('data-image'));
          img.style.opacity = '1';
          if (caption) caption.textContent = btn.getAttribute('data-label') || '';
          buttons.forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
        }, 150);
      }
      var renderToken = 0;
      var autoTimer = null;
      function startAuto() {
        if (!auto || buttons.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        autoTimer = setInterval(function () { show((index + 1) % buttons.length); }, 2600);
      }
      buttons.forEach(function (btn, i) {
        btn.addEventListener('click', function () {
          if (autoTimer) { clearInterval(autoTimer); autoTimer = null; }
          show(i);
          startAuto();
        });
      });
      if (buttons.length) show(0);
      startAuto();
    });
  }

  function initCountUp() {
    var els = document.querySelectorAll('[data-db-countup]');
    if (!els.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        io.unobserve(el);
        var target = parseFloat(el.getAttribute('data-db-countup')) || 0;
        var decimals = (el.getAttribute('data-decimals') || '0') === '1' ? 1 : 0;
        var duration = 1400;
        var start = performance.now();
        function frame(now) {
          var p = Math.min(1, (now - start) / duration);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = (target * eased).toFixed(decimals);
          if (p < 1) requestAnimationFrame(frame);
        }
        requestAnimationFrame(frame);
      });
    }, { threshold: 0.4 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initFaq() {
    document.querySelectorAll('[data-db-faq-item]').forEach(function (item) {
      var trigger = item.querySelector('[data-db-faq-trigger]');
      if (!trigger) return;
      trigger.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        item.closest('[data-db-faq]').querySelectorAll('[data-db-faq-item]').forEach(function (i) {
          i.classList.remove('is-open');
          var t = i.querySelector('[data-db-faq-trigger]');
          if (t) t.setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          item.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  function initVariants() {
    document.querySelectorAll('[data-db-product-form]').forEach(function (form) {
      var variantsJson = form.querySelector('[data-db-variants-json]');
      if (!variantsJson) return;
      var variants;
      try { variants = JSON.parse(variantsJson.textContent); } catch (e) { return; }
      var optionInputs = form.querySelectorAll('[data-db-option]');
      var idInput = form.querySelector('[data-db-variant-id]');
      var priceEl = form.querySelector('[data-db-price]');
      var comparePriceEl = form.querySelector('[data-db-compare-price]');
      var addBtn = form.querySelector('[data-db-add-btn]');
      function money(cents) {
        return (cents / 100).toLocaleString(document.documentElement.lang || 'es', {
          style: 'currency',
          currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR'
        });
      }
      function currentSelection() {
        var sel = [];
        optionInputs.forEach(function (group) {
          var checked = group.querySelector('input:checked, select');
          if (checked) sel.push(checked.value || checked.options[checked.selectedIndex].value);
        });
        return sel;
      }
      function findVariant(sel) {
        return variants.find(function (v) {
          return v.options.every(function (opt, i) { return opt === sel[i]; });
        });
      }
      function update() {
        var sel = currentSelection();
        var variant = findVariant(sel);
        if (!variant) return;
        if (idInput) idInput.value = variant.id;
        if (priceEl) priceEl.textContent = money(variant.price);
        if (comparePriceEl) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            comparePriceEl.textContent = money(variant.compare_at_price);
            comparePriceEl.style.display = '';
          } else {
            comparePriceEl.style.display = 'none';
          }
        }
        if (addBtn) {
          addBtn.disabled = !variant.available;
          addBtn.toggleAttribute('aria-disabled', !variant.available);
          var addBtnLabel = addBtn.querySelector('span') || addBtn;
          addBtnLabel.textContent = variant.available
            ? addBtn.getAttribute('data-label-available')
            : addBtn.getAttribute('data-label-soldout');
        }
      }
      optionInputs.forEach(function (group) {
        group.addEventListener('change', update);
      });
      update();
    });
  }

  function initVideoRow() {
    document.querySelectorAll('[data-db-video-row]').forEach(function (row) {
      var isDown = false, startX = 0, startScroll = 0, moved = false;

      function onMove(e) {
        if (!isDown) return;
        if (e.buttons === 0) { onUp(); return; }
        var dx = e.pageX - startX;
        if (Math.abs(dx) > 4) moved = true;
        row.scrollLeft = startScroll - dx;
      }
      function onUp() {
        if (!isDown) return;
        isDown = false;
        row.classList.remove('is-dragging');
        document.removeEventListener('mousemove', onMove);
        document.removeEventListener('mouseup', onUp);
      }
      row.addEventListener('mousedown', function (e) {
        isDown = true; moved = false;
        startX = e.pageX; startScroll = row.scrollLeft;
        row.classList.add('is-dragging');
        document.addEventListener('mousemove', onMove);
        document.addEventListener('mouseup', onUp);
      });
      row.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);

      var wrap = row.closest('[data-db-video-wrap]');
      if (!wrap) return;
      var prev = wrap.querySelector('[data-db-video-prev]');
      var next = wrap.querySelector('[data-db-video-next]');
      var scrollByCard = function (dir) {
        var card = row.querySelector('.db-videos__card');
        var step = card ? card.getBoundingClientRect().width + 18 : 220;
        row.scrollLeft = row.scrollLeft + (dir * step);
      };
      if (prev) prev.addEventListener('click', function () { scrollByCard(-1); });
      if (next) next.addEventListener('click', function () { scrollByCard(1); });
    });
  }

  function initBundlePicker() {
    document.querySelectorAll('[data-db-bundle-picker]').forEach(function (picker) {
      var scope = picker.closest('section') || document;
      var cards = picker.querySelectorAll('[data-db-bundle-card]');
      var addBtns = scope.querySelectorAll('[data-db-bundle-add]');
      var priceEls = scope.querySelectorAll('[data-db-bundle-price-display]');
      var qtyInput = scope.querySelector('[data-db-bundle-qty]');

      function select(card) {
        cards.forEach(function (c) {
          c.classList.remove('is-selected');
          var input = c.querySelector('input');
          if (input) input.checked = false;
        });
        card.classList.add('is-selected');
        var input = card.querySelector('input');
        if (input) input.checked = true;

        var va = card.getAttribute('data-variant-a') || '';
        var qa = card.getAttribute('data-qty-a') || '0';
        var vb = card.getAttribute('data-variant-b') || '';
        var qb = card.getAttribute('data-qty-b') || '0';
        var priceLabel = card.getAttribute('data-price-label') || '';

        addBtns.forEach(function (btn) {
          btn.setAttribute('data-variant-a', va);
          btn.setAttribute('data-qty-a', qa);
          btn.setAttribute('data-variant-b', vb);
          btn.setAttribute('data-qty-b', qb);
        });
        priceEls.forEach(function (el) { el.textContent = priceLabel; });
      }

      cards.forEach(function (card) {
        card.addEventListener('click', function () { select(card); });
      });

      var initial = picker.querySelector('.is-selected') || cards[0];
      if (initial) select(initial);

      addBtns.forEach(function (addBtn) {
        addBtn.addEventListener('click', function () {
          if (addBtn.classList.contains('is-loading')) return;
          addBtns.forEach(function (b) { b.classList.add('is-loading'); });
          var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
          var items = [];
          var va = addBtn.getAttribute('data-variant-a');
          var vb = addBtn.getAttribute('data-variant-b');
          var qa = parseInt(addBtn.getAttribute('data-qty-a'), 10) || 0;
          var qb = parseInt(addBtn.getAttribute('data-qty-b'), 10) || 0;
          if (va && qa > 0) items.push({ id: va, quantity: qa * qty });
          if (vb && qb > 0) items.push({ id: vb, quantity: qb * qty });
          if (!items.length) { addBtns.forEach(function (b) { b.classList.remove('is-loading'); }); return; }
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: items })
          })
            .then(function (r) { if (!r.ok) throw new Error('cart add failed'); return r.json(); })
            .then(function () { window.location.href = '/cart'; })
            .catch(function () {
              addBtns.forEach(function (b) { b.classList.remove('is-loading'); });
              window.location.href = '/cart';
            });
        });
      });
    });
  }

  function initMiniReviews() {
    document.querySelectorAll('[data-db-mini-reviews]').forEach(function (widget) {
      var reviews = widget.querySelectorAll('.db-producto__mini-review');
      var dots = widget.querySelectorAll('[data-db-mini-review-dot]');
      if (reviews.length < 2) return;
      var index = 0;
      var timer = null;

      function show(i) {
        index = i;
        reviews.forEach(function (r, ri) { r.classList.toggle('is-active', ri === i); });
        dots.forEach(function (d, di) { d.classList.toggle('is-active', di === i); });
      }

      function restart() {
        if (timer) clearInterval(timer);
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        timer = setInterval(function () { show((index + 1) % reviews.length); }, 4500);
      }

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () { show(i); restart(); });
      });

      restart();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveals();
    initCountdown();
    initGallery();
    initSceneSwitcher();
    initCountUp();
    initFaq();
    initVariants();
    initVideoRow();
    initBundlePicker();
    initMiniReviews();
  });
})();
